import BigNumber from 'bignumber.js'
import { BIG_ONE, BIG_ZERO } from 'utils/bigNumber'
import { filterFarmsByQuoteToken } from '@noahswap/farms'
import { SerializedFarm } from 'state/types'
import { evmTokens } from '@noahswap/tokens'

const getFarmFromTokenSymbol = (
  farms: SerializedFarm[],
  tokenSymbol: string,
  preferredQuoteTokens?: string[],
): SerializedFarm => {
  const farmsWithTokenSymbol = farms.filter((farm) => farm.token.symbol === tokenSymbol)
  const filteredFarm = filterFarmsByQuoteToken(farmsWithTokenSymbol, preferredQuoteTokens)
  return filteredFarm
}

const getFarmBaseTokenPrice = (
  farm: SerializedFarm,
  quoteTokenFarm: SerializedFarm,
  eosPriceEusd: BigNumber,
): BigNumber => {
  const hasTokenPriceVsQuote = Boolean(farm.tokenPriceVsQuote)

  // if (farm.quoteToken.symbol === evmTokens.eusd.symbol) {
  //   return hasTokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : BIG_ZERO
  // }

  // if (farm.quoteToken.symbol === evmTokens.weos.symbol) {
  //   return hasTokenPriceVsQuote ? eosPriceEusd.times(farm.tokenPriceVsQuote) : BIG_ZERO
  // }

  // We can only calculate profits without a quoteTokenFarm for EUSD/EOS farms
  if (!quoteTokenFarm) {
    return BIG_ZERO
  }

  // Possible alternative farm quoteTokens:
  // UST (i.e. MIR-UST), pBTC (i.e. PNT-pBTC), BTCB (i.e. bBADGER-BTCB), ETH (i.e. SUSHI-ETH)
  // If the farm's quote token isn't EUSD or WEOS, we then use the quote token, of the original farm's quote token
  // i.e. for farm PNT - pBTC we use the pBTC farm's quote token - EOS, (pBTC - EOS)
  // from the EOS - pBTC price, we can calculate the PNT - EUSD price
  // if (quoteTokenFarm.quoteToken.symbol === evmTokens.weos.symbol) {
  //   const quoteTokenInEusd = eosPriceEusd.times(quoteTokenFarm.tokenPriceVsQuote)
  //   return hasTokenPriceVsQuote && quoteTokenInEusd
  //     ? new BigNumber(farm.tokenPriceVsQuote).times(quoteTokenInEusd)
  //     : BIG_ZERO
  // }

  // if (quoteTokenFarm.quoteToken.symbol === evmTokens.eusd.symbol) {
  //   const quoteTokenInEusd = quoteTokenFarm.tokenPriceVsQuote
  //   return hasTokenPriceVsQuote && quoteTokenInEusd
  //     ? new BigNumber(farm.tokenPriceVsQuote).times(quoteTokenInEusd)
  //     : BIG_ZERO
  // }

  // Catch in case token does not have immediate or once-removed EUSD/WEOS quoteToken
  return BIG_ZERO
}

const getFarmQuoteTokenPrice = (
  farm: SerializedFarm,
  quoteTokenFarm: SerializedFarm,
  eosPriceEusd: BigNumber,
): BigNumber => {
  if (farm.quoteToken.symbol === 'EUSD') {
    return BIG_ONE
  }

  if (farm.quoteToken.symbol === 'WEOS') {
    return eosPriceEusd
  }

  if (!quoteTokenFarm) {
    return BIG_ZERO
  }

  if (quoteTokenFarm.quoteToken.symbol === 'WEOS') {
    return quoteTokenFarm.tokenPriceVsQuote ? eosPriceEusd.times(quoteTokenFarm.tokenPriceVsQuote) : BIG_ZERO
  }

  if (quoteTokenFarm.quoteToken.symbol === 'EUSD') {
    return quoteTokenFarm.tokenPriceVsQuote ? new BigNumber(quoteTokenFarm.tokenPriceVsQuote) : BIG_ZERO
  }

  return BIG_ZERO
}

const getFarmsPrices = (farms: SerializedFarm[]) => {
  const eosEusdFarm = farms.find((farm) => farm.v1pid === 252)
  const eosPriceEusd = eosEusdFarm.tokenPriceVsQuote ? BIG_ONE.div(eosEusdFarm.tokenPriceVsQuote) : BIG_ZERO

  const farmsWithPrices = farms.map((farm) => {
    const quoteTokenFarm = getFarmFromTokenSymbol(farms, farm.quoteToken.symbol)
    const tokenPriceEusd = getFarmBaseTokenPrice(farm, quoteTokenFarm, eosPriceEusd)
    const quoteTokenPriceEusd = getFarmQuoteTokenPrice(farm, quoteTokenFarm, eosPriceEusd)

    return {
      ...farm,
      tokenPriceEusd: tokenPriceEusd.toJSON(),
      quoteTokenPriceEusd: quoteTokenPriceEusd.toJSON(),
    }
  })

  return farmsWithPrices
}

export default getFarmsPrices
